var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"d-flex align-items-center"},[_c('order-plan-button',{staticClass:"d-none d-lg-inline-block th-mr-16",attrs:{"sm":""}}),_c('header-profile-menu',{staticClass:"th-mx-16",attrs:{"name":_vm.name}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }